import clsx from 'clsx';
import { Color } from '../../types/common';

type StatusChipProps = {
  statusText: string;
  textColor?: string;
  bgColor?: string;
  borderColor?: string;
  themeColor?: Color;
  showBorder?: boolean;
  additionalClasses?: string;
};

const StatusChip = ({
  statusText,
  textColor,
  bgColor,
  borderColor,
  themeColor,
  showBorder,
  additionalClasses,
}: StatusChipProps) => {
  return (
    <div
      className={clsx(
        'w-fit rounded p-1 text-xs',
        textColor ? `text-[${textColor}]` : '',
        bgColor ? `bg-[${bgColor}]` : '',
        borderColor ? `border border-solid border-[${borderColor}]` : '',
        themeColor === 'green'
          ? 'bg-[#ecf6ee] text-[#18855E]'
          : themeColor === 'red'
          ? 'bg-[#f9e5e5] text-[#D02B2B]'
          : themeColor === 'grey'
          ? 'bg-[#f3f4f6] text-greyishBlue'
          : 'bg-[#fff5e9] text-[#DF8518]',
        showBorder ?
            themeColor === 'green'
            ? 'border border-solid border-[#84ff97]'
            : themeColor === 'red'
            ? 'border border-solid border-[#f7ddde]'
            : themeColor === 'grey'
            ? 'border border-solid border-backgroundGrey'
            : 'border border-solid border-[#f9dfbf]'
            : '',
        additionalClasses
      )}
    >
      {statusText}
    </div>
  );
};

export default StatusChip;
